import React from "react";
import MobileBowlerCard from "./MobileBowlerCard";

const MobileCards = ({
  tournamentBowlers,
  emptyMessage,
  canManageAndLoggedIn,
  editingBowlerId,
  editedAverage,
  editedHasAverage,
  errorMessage,
  verifyingBowlerId,
  verifyingAll,
  onEditClick,
  onAverageChange,
  onSaveClick,
  onCancelClick,
  onVerifyClick,
  onHasAverageChange,
  onUseCatalogAverage,
  onReview,
  canVerifyBowlerForEdit,
  canUnverifyBowlerForEdit,
}) => {
  return (
    <div className="md:hidden">
      {tournamentBowlers.bowlerData.length === 0 ? (
        <p className="px-4 py-8 text-sm text-brand-muted text-center">
          {emptyMessage}
        </p>
      ) : (
        <div className="space-y-2 px-4 pb-4">
          {tournamentBowlers.bowlerData.map((bowler) => (
            <MobileBowlerCard
              key={bowler.bowlerId}
              bowler={bowler}
              isEditing={editingBowlerId === bowler.bowlerId}
              editedAverage={editedAverage}
              editedHasAverage={editedHasAverage}
              errorMessage={errorMessage}
              canManage={canManageAndLoggedIn}
              verifyingBowlerId={verifyingBowlerId}
              verifyingAll={verifyingAll}
              onEditClick={onEditClick}
              onAverageChange={onAverageChange}
              onHasAverageChange={onHasAverageChange}
              onSaveClick={onSaveClick}
              onCancelClick={onCancelClick}
              onVerifyClick={onVerifyClick}
              onUseCatalogAverage={onUseCatalogAverage}
              onReview={onReview}
              canVerify={
                canVerifyBowlerForEdit
                  ? canVerifyBowlerForEdit(bowler.bowlerId)
                  : false
              }
              canUnverify={canUnverifyBowlerForEdit(bowler.bowlerId)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileCards;
